import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
// import * as CryptoJS from 'crypto-js';
import { API } from 'src/app/configs/api.config';
import { ActivatedRoute } from '@angular/router';
import { LoaderService } from './loader.service';

interface UserInfo {
    avatar: string,
    bind: [],
    bindWxMsg?: boolean,
    bindGithub?: boolean,
    groups: number,
    phone: string,
    username: string,
    userId: string,
}

@Injectable()
export class AuthService {

    userInfo: UserInfo = {
        avatar: '',
        bind: [],
        bindWxMsg: false,
        bindGithub: false,
        groups: 0,
        phone: '',
        username: '',
        userId: '',
    };

    isLogin = false;

    tokens = {
        access_token: "",
        refresh_token: ""
    };

    // avatar;
    // username;
    // phone;

    constructor(
        private http: HttpClient,
        private activatedRoute: ActivatedRoute,
        private loaderService: LoaderService
    ) { }


    checkAuth(): boolean {
        let tokensString = localStorage.getItem('blinker_token_sso');
        // console.log(tokensString);

        if (tokensString == null) {
            this.gotoSSO()
        } else {
            this.tokens = JSON.parse(tokensString);
            this.getUserInfo();
            return true
        }
    }

    gotoSSO() {
        if (this.isdebug())
            window.location.href = 'https://sso.clz.me?sourceUrl=http://' + window.location.host;
        else
            window.location.href = this.loaderService.config.sso_url + '?sourceUrl=http://' + window.location.host;
    }

    getUserInfo() {
        this.http.get<ResponseModel>(API.USER_INFO)
            .toPromise().then((res: any) => {
                console.log(res);
                if (res.message == 1000) {
                    this.userInfo = res.detail
                    this.userInfo.avatar = API.AVATAR + res.detail.avatar + '.jpg';
                    // this.userInfo.username = res.detail.username
                    // this.userInfo.phone = res.detail.phone
                    // this.userInfo.groups = res.detail.groups
                    // this.userInfo.bindWxMsg = res.detail.bindWxMsg
                    // this.userInfo.bindGithub = res.detail.bindGithub
                    // this.userInfo.userId = res.detail.userId
                    this.isLogin = true;
                    this.loaderService.loadUserConfig(this.userInfo.groups)
                    console.log(this.userInfo);
                } else if (res.message == 1001) {
                    this.isLogin = false;
                    // localStorage.removeItem('blinker_token_sso');
                    // window.location.href = AppConfig.sso_url + '?sourceUrl=https://' + window.location.hostname;
                }
            })
    }

    refreshToken() {
        this.http.post<ResponseModel>(API.TOKEN, {}, {
            headers: {
                "Authorization": 'Bearer ' + this.tokens.refresh_token
            }
        }).subscribe((res: any) => {
            console.log(res);
            if (res.message == 1000) {
                console.log(res.detail.access_token);
                this.tokens.access_token = res.detail.access_token;
                localStorage.setItem('blinker_token_sso', JSON.stringify(this.tokens));
                location.reload();
            }
            // else if (res.message == 1002) {
            //     this.isLogin = false;
            //     localStorage.removeItem('blinker_token_sso');
            //     window.location.href = AppConfig.sso_url + '?sourceUrl=https://' + window.location.hostname;
            // }
        })
    }

    logout() {
        if (typeof this.tokens.access_token == 'undefined' || this.tokens.access_token == "") {
            localStorage.removeItem('blinker_token_sso');
            window.location.href = this.loaderService.config.main_url;
            return
        }

        return this.http.delete<ResponseModel>(API.LOGOUT, {
            headers: {
                "Authorization": 'Bearer ' + this.tokens.access_token
            }
        }).toPromise().then((res: any) => {
            console.log(res);
            if (res.message == 1000) {
                this.isLogin = false;
                localStorage.removeItem('blinker_token_sso');
                window.location.href = this.loaderService.config.main_url;;
                return true
            } else if (res.message == 1001) {
                localStorage.removeItem('blinker_token_sso');
                window.location.href = this.loaderService.config.main_url;;
                return false
            }
        })
    }

    sendSmscode(phone, sendType) {
        return this.http.get<ResponseModel>(API.SMSCODE, {
            params: {
                phone: phone,
                sendType: sendType
            }
        }).toPromise().then(
            (response: ResponseModel) => {
                console.log(response);
                if (response.message == 1000) {
                    return true
                } else {
                    return false
                }
            })
    }

    isdebug() {
        return window.location.hostname.indexOf('localhost') > -1 || window.location.hostname.indexOf('sso2.diandeng.tech') > -1 || window.location.hostname.indexOf('sso.clz.me') > -1
    }
}
